export class ProjectModel {
	name = '';
	location = '';
	client = '';
	title = '';

	constructor(
		name,
		location,
		client,
		title,
	) {
		this.name = name || '';
		this.location = location || '';
		this.client = client || '';
		this.title = title || '';
	}
}